import axios from "axios";

export default function getSvgComponents({ signal }) {
  const source = axios.CancelToken.source();

  if (signal) {
    signal.addEventListener("abort", () => {
      source.cancel();
    });
  }

  return ({ url, fill }) => {
    return axios
      .get(url, { cancelToken: source.token })
      .then(({ data }) => {
        const viewBoxMatch = data.match(/viewBox="([^"]*)"/);
        if (!viewBoxMatch) {
          console.warn(`SVG at ${url} is missing a viewBox attribute`);
          return null;
        }
        const viewBox = viewBoxMatch[1];
        const paths = data.match(/<path\b([\s\S]*?)\/>/g);
        if (!paths) {
          console.warn(`SVG at ${url} contains no <path> elements`);
        }
        return { fill, viewBox, paths };
      })
      .catch((error) => {
        if (axios.isCancel(error)) return null;
        console.warn(`Failed to fetch SVG from ${url}:`, error.message);
        return null;
      });
  };
}
